import React from 'react';
import get from 'lodash/get';
import InputItem from 'views/pages/ClientDetail/components/InputItem';
import {
  Section,
  FormSection,
  ListInfo,
  Title,
} from 'views/pages/ClientDetail/components/Elements';
import { QUARTERS } from 'helper/const';
import CollapseSection from 'views/pages/ClientDetail/components/CollapseSection';
import { checkTabHasFile } from 'views/pages/ClientDetail/components/Filling/utils';
import {
  LICENSE_OBJ_KEYS,
  LICENSE1_OBJ_KEYS,
  LICENSE2_OBJ_KEYS,
} from '../../tabConstants/ifta';

const License = ({ years, form, data, handleYearSubmit, initialValues }) => {
  const tYears = years || [];

  return (
    <Section flexBox>
      {tYears.map(year => {
        const mainName = `ifta_license_year_wise_${year}`;
        return (
          <CollapseSection
            hasFile={checkTabHasFile(
              [
                ...LICENSE_OBJ_KEYS(year),
                ...LICENSE1_OBJ_KEYS(year),
                ...LICENSE2_OBJ_KEYS(year),
              ],
              data
            )}
            onEdit={() => {
              const fieldObj = {
                delete_attachments: [],
                [mainName]: get(initialValues, mainName),
              };
              QUARTERS.forEach(obj => {
                const returnName = `ifta_q${obj.value}_return_year_wise_${year}`;
                const receiptName = `ifta_q${obj.value}_receipt_year_wise_${year}`;
                const totalsName = `ifta_q${obj.value}_totals_year_wise_${year}`;
                fieldObj[returnName] = get(initialValues, returnName);
                fieldObj[receiptName] = get(initialValues, receiptName);
                fieldObj[totalsName] = get(initialValues, totalsName);
              });
              form.setFieldsValue(fieldObj);
            }}
            key={year}
            form={form}
            title={year}
            onSubmit={(values, cb) => {
              if (handleYearSubmit) handleYearSubmit(values, cb);
            }}
            renderContent={isEdit => {
              return (
                <>
                  {isEdit ? (
                    <>
                      <FormSection>
                        <InputItem
                          name={'delete_attachments'}
                          label=""
                          form={form}
                          hide
                        />
                        <InputItem
                          name={mainName}
                          label="IFTA License"
                          form={form}
                          type="file"
                        />
                      </FormSection>
                      <Title text="Quarterly Filings" />
                      <FormSection>
                        {QUARTERS.map(obj => {
                          return (
                            <React.Fragment key={obj.value}>
                              <InputItem
                                name={`ifta_q${obj.value}_return_year_wise_${year}`}
                                label={`${obj.label} Return`}
                                form={form}
                                type="file"
                              />
                              <InputItem
                                name={`ifta_q${obj.value}_receipt_year_wise_${year}`}
                                label={`${obj.label} Receipt`}
                                form={form}
                                type="file"
                              />
                            </React.Fragment>
                          );
                        })}
                      </FormSection>
                      <Title text="Quarterly Totals" />
                      <FormSection>
                        {QUARTERS.map(obj => {
                          return (
                            <React.Fragment key={obj.value}>
                              <InputItem
                                name={`ifta_q${obj.value}_totals_year_wise_${year}`}
                                label={`${obj.label} Totals`}
                                form={form}
                                type="file"
                              />
                            </React.Fragment>
                          );
                        })}
                      </FormSection>
                    </>
                  ) : (
                    <>
                      <ListInfo
                        objKeys={LICENSE_OBJ_KEYS(year)}
                        data={data}
                        noPadding
                      />
                      <Title text="Quarterly Filings" />
                      <ListInfo
                        objKeys={LICENSE1_OBJ_KEYS(year)}
                        data={data}
                        noPadding
                      />
                      <Title text="Quarterly Totals" />
                      <ListInfo
                        objKeys={LICENSE2_OBJ_KEYS(year)}
                        data={data}
                        noPadding
                      />
                    </>
                  )}
                </>
              );
            }}
          />
        );
      })}
    </Section>
  );
};

export default License;
